import UserImage from "../../UserImage";
import taskModalStyles from "./EditTaskModal.module.scss";

export const CommentInputBox = ({ onChange, onSubmit, onCancel, text }) => {
  return (
    <div className={taskModalStyles.comment_container}>
      <UserImage />
      <textarea
        className={taskModalStyles.comment}
        placeholder="Aggiungi un commento..."
        value={text}
        onChange={(e) => onChange(e.target.value)}
      ></textarea>
      <button
        className={"button_var1" + (!text ? " disabled" : "")}
        onClick={() => onSubmit()}
      >
        Salva
      </button>
      {onCancel && (
        <button className="button" onClick={() => onCancel()}>
          Annulla
        </button>
      )}
    </div>
  );
};
